import jwt from 'jwt-decode';
import * as actionTypes from 'actions';
import config from 'configuration/configuration.js';

const token = localStorage.getItem(config.TOKEN_KEY);
let initialState = {
	loggedIn: false,
	user: {
	},
	notifications: [],
	isLoading: false,
	loadingCount: 0,
	downloads: [],
	downloadskey: 'all',
};

if (token) {
	const decoded = jwt(token);
	const currentDate = new Date().getTime() / 1000;
	if (decoded.exp > currentDate) {
		initialState = { ...initialState, loggedIn: true, user: { ...decoded } };
	}
}

const sessionReducer = (state = initialState, action) => {
	switch (action.type) {
					case actionTypes.REDIRECT_TO_ERROR: {
						return {
							...state,
							link: action.link
						};
					}
					case actionTypes.SESSION_LOGIN: {
						return {
							...state,
							loggedIn: true
						};
					}
					case actionTypes.USER_INFO: {
						return {
							...state,
							user: { ...state.user, ...action.user }
						};
					}
					case actionTypes.SESSION_LOGOUT: {
						return {
							...state,
							loggedIn: false,
							user: {
								role: 'Client',
							},
						};
					}
					case actionTypes.SET_NOTIFICATIONS: {
						return {
							...state,
							notifications: action.notifications || [],
						};
					}
					case actionTypes.SET_DOWNLOADS: {
						return {
							...state,
							downloads: action.downloads || [],
							downloadskey: action.downloadskey || 'all'
						};
					}
					case actionTypes.SET_LOADING: {
						return {
							...state,
							// eslint-disable-next-line no-param-reassign
							loadingCount: action.isLoading ? state.loadingCount++ : state.loadingCount--,
							isLoading: state.loadingCount > 0,
						};
					}
					default: {
						return state;
					}
	}
};

export default sessionReducer;
